(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[710],{

/***/ 1710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CardsSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(608);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2606);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6684);
/* harmony import */ var _cards_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9920);
/* harmony import */ var _cards_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cards_module_css__WEBPACK_IMPORTED_MODULE_6__);







function Card(param) {
    let { children , link  } = param;
    const className = "py-4 md:py-0";
    if (link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: link.url,
            className: className,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: children
    });
}
function CardsSection(param) {
    let { data: { elements  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_1__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md:grid md:grid-cols-12 md:gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-start-1 col-span-12 lg:col-start-3 lg:col-span-8 grid grid-cols-1 md:grid-cols-2 md:gap-6 pointer-events-none", {
                    [(_cards_module_css__WEBPACK_IMPORTED_MODULE_6___default().cards)]: elements.length !== 2 && elements.some((e)=>e.link)
                }),
                children: elements.map((param, index)=>/*#__PURE__*/ {
                    let { overline , title , html , link  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                        link: link,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex flex-col text-white px-6 py-12 rounded-xl md:rounded-3xl h-full group transition duration-300 pointer-events-auto", {
                                "bg-blue-500": elements.length !== 2 || index !== 1,
                                "hover:bg-blue-800 hover:scale-105": (elements.length !== 2 || index !== 1) && link,
                                "bg-iceblue-500": elements.length === 2 && index === 1,
                                "hover:bg-[#4DA7B5] hover:scale-105": elements.length === 2 && index === 1 && link,
                                "md:relative md:top-12": index % 2 === 1
                            }),
                            children: [
                                overline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-bold text-17 leading-140 md:text-20", {
                                        "text-iceblue-500": elements.length !== 2 || index !== 1,
                                        "text-iceblue-800": elements.length === 2 && index === 1
                                    }),
                                    children: overline
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-white font-bold text-28 leading-125 md:text-35 leading-130 mb-8", {
                                        "mt-8": overline
                                    }),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex-1 prose",
                                    dangerouslySetInnerHTML: {
                                        __html: html
                                    }
                                }),
                                link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("uppercase font-bold text-white text-13 leading-140 tracking-5 inline-flex items-center mt-24"),
                                    children: [
                                        link.text,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowIcon */ .e0, {
                                            className: "w-12 ml-4 transition-transform duration-500 group-hover:translate-x-2"
                                        })
                                    ]
                                })
                            ]
                        }, index)
                    }, index);
                })
            })
        })
    });
}


/***/ }),

/***/ 9920:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cards":"cards_cards__h3oaT"};

/***/ })

}]);